import { useEffect, useState } from 'react';
import { Dialog, useMediaQuery } from '@mui/material';
import { Close } from '@mui/icons-material';
import eventBus from '../../../eventBus';
import EmailModalContent from './EmailModalContent';

const useStyles = () => ({
  container: {
    borderRadius: '10px',
    boxShadow: '0 5px 20px rgba(0, 0, 0, 0.07)',
    maxWidth: '600px',
    padding: {
      xxs: '48px 0px 0px',
      xs: '30px',
    },
  },
});

export default function EmailModal() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  function handleClose() {
    setOpen(false);
  }
  useEffect(() => {
    eventBus.on('openEmailModal', () => {
      setOpen(true);
    });
    return () => {
      eventBus.remove('openEmailModal');
    };
  }, []);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      fullScreen={isXS}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: classes.container,
      }}
    >
      <Close
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: '12px',
          top: '12px',
          color: '#4D586F',
          cursor: 'pointer',
        }}
      />
      <EmailModalContent setOpen={setOpen} />
    </Dialog>
  );
}
